import React from "react";
import { Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import classNames from "classnames";
import "./style.css";

import Button from "../../../../../components/common/button/Button";
import styles from "./VerifyAccount.scss";
import icon from "../../../../../assets/images/help.svg";
import Input from "../../../../../components/common/input/Input";
import Checkbox from "../../../../../components/common/checkbox/Checkbox";
import ModalWrapper from "../../../../../components/common/modalWrapper/ModalWrapper";
import Error from "../../../../../components/common/error/Error";
import { VERIFY_ACCOUNT_FORM } from "../../../../../actions/user.actions";
import {
  required,
  creditCard,
  numeric,
  cardExpDate
} from "../../../../../utils/forms/validators";
import FeesModal from "./FeesModal/FeesModal";

const isCreditCardNum = creditCard("Please use a valid credit card number");
const numberMsg = numeric("This Field must be a number");
const isCardExpDate = cardExpDate(
  "The expiration date does not match the format MM/YY."
);

class VerifyAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showReferralCode: false
    };
  }

  render() {
    const {
      handleSubmit,
      submitting,
      invalid,
      pristine,
      revalidateField,
      revalidate: { number, name, ccv, expiration_date }
    } = this.props;

    return (
      <section className={styles.companyVerifyAccount}>
        <div className={styles.content}>
          <h2 className={styles.title}>Verify Your Account</h2>

          <Form className={styles.form} onSubmit={handleSubmit}>
            <div>
              <p className={classNames(styles.subtitle, styles.textCentre)}>
                We validate accounts with a credit card for the protection of
                our members and to ensure the legitimacy of the companies
                posting on our site. <br />
                <strong
                  className={classNames(
                    styles.secondParagraph,
                    styles.textCentre,
                    styles.subtitle
                  )}
                >
                  We will not charge your credit card without your consent.
                </strong>
              </p>

              <p
                className={classNames(
                  styles.secondParagraph,
                  styles.textCentre,
                  styles.subtitle
                )}
              >
                Our flat fee:
              </p>

              <div className={classNames(styles.subtitle, styles.textCentre)}>
                We charge you a 15% fee on top of every submitted invoice.
                Members pay a 5% fee.
                <br />
                <ModalWrapper Modal={FeesModal}>
                  <div className={styles.modalTrigger}>
                    Learn more about our fees.
                  </div>
                </ModalWrapper>
              </div>
            </div>
            <hr className={styles.hr} />
            <hr className={styles.hr} />
            <div className={styles.referralCodeCheckboxContainer}>
              <label className={styles.checkbox}>
                <Field
                  name="codeCheckBox"
                  formGroupClassName={styles.referralCodeCheckbox}
                  component={Checkbox}
                  onChange={this.toggleShowReferralCode.bind(this)}
                />
                <span className={styles.checkboxText}>
                  I received a referral code from The Second Shift.
                </span>
              </label>
              <OverlayTrigger
                overlay={this.getTooltip()}
                onEntering={this.handleOnEnteringOverlay}
              >
                <img src={icon} className={styles.questionSignIcon} />
              </OverlayTrigger>
            </div>
            <div className={styles.formContent}>
              {this.state.showReferralCode ? (
                this.renderReferralCodeField()
              ) : (
                <div>
                  <Field
                    name="number"
                    type="text"
                    placeholder="Credit Card Number"
                    forceError={
                      this.props.forceError != null && !number ? true : false
                    }
                    onChange={revalidateField}
                    component={Input}
                    validate={[required, isCreditCardNum]}
                  />

                  <Field
                    name="name"
                    type="text"
                    placeholder="Name on Card"
                    forceError={
                      this.props.forceError != null && !name ? true : false
                    }
                    onChange={revalidateField}
                    component={Input}
                    validate={[required]}
                  />

                  <Field
                    name="ccv"
                    formGroupClassName={styles.shortInput}
                    type="text"
                    forceError={
                      this.props.forceError != null && !ccv ? true : false
                    }
                    onChange={revalidateField}
                    placeholder="CCV"
                    component={Input}
                    validate={[required, numberMsg]}
                  />

                  <Field
                    name="expiration_date"
                    formGroupClassName={classNames(
                      styles.shortInput,
                      styles.lastInput
                    )}
                    type="text"
                    forceError={
                      this.props.forceError != null && !expiration_date
                        ? true
                        : false
                    }
                    onChange={revalidateField}
                    placeholder="Exp. Date"
                    component={Input}
                    validate={[required, isCardExpDate]}
                  />
                </div>
              )}
            </div>
            <hr className={styles.hr} />
            <hr className={styles.hr} />
            <div className={styles.formContent}>
              {!this.state.showReferralCode && (
                <p className={classNames(styles.subtitle, styles.subtitleGrey)}>
                  We will not charge your credit card until your project is
                  completed and invoiced.
                </p>
              )}

              <Button
                isPrimary
                type="submit"
                size={"large"}
                label="Verify"
                isDisabled={invalid || submitting || pristine}
              />

              <Error />
            </div>
          </Form>
        </div>
      </section>
    );
  }

  renderReferralCodeField() {
    return (
      <Field
        name="referral_code"
        formGroupClassName={styles.lastInput}
        type="text"
        placeholder="Referral Code"
        component={Input}
        validate={[required]}
      />
    );
  }

  toggleShowReferralCode() {
    this.props.removeErrors();

    this.setState(prevState => {
      return {
        showReferralCode: !prevState.showReferralCode
      };
    });
  }

  handleOnEnteringOverlay(e) {
    e.children[1].style.textAlign = "left";
  }

  getTooltip() {
    return (
      <Tooltip id="referral-code-tooltip" className={"tooltipGrey"}>
        If a member of The Second Shift team provided you with a referral code,
        check here to enter it. If not, you may ignore this box.
      </Tooltip>
    );
  }
}

export default (VerifyAccount = reduxForm({
  form: VERIFY_ACCOUNT_FORM
})(VerifyAccount));



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/components/VerifyAccount/VerifyAccount.js